export type EquipmentCategory =
  | 'lower_body'
  | 'back'
  | 'chest'
  | 'shoulders'
  | 'arms'
  | 'core'
  | 'multi_function'
  | 'cardio'
  | 'free_weights'
  | 'resistance_bands'
  | 'core_stability'
  | 'functional'
  | 'structures';

export const EQUIPMENT_CATEGORY_ORDER: readonly EquipmentCategory[] = [
  'lower_body',
  'back',
  'chest',
  'shoulders',
  'arms',
  'core',
  'multi_function',
  'cardio',
  'free_weights',
  'resistance_bands',
  'core_stability',
  'functional',
  'structures',
] as const;

export const EQUIPMENT_CATEGORY_LABELS: Record<EquipmentCategory, string> = {
  lower_body: 'Membros inferiores',
  back: 'Costas',
  chest: 'Peito',
  shoulders: 'Ombros',
  arms: 'Braços',
  core: 'Core',
  multi_function: 'Multifuncionais',
  cardio: 'Cardio',
  free_weights: 'Pesos livres',
  resistance_bands: 'Elásticos',
  core_stability: 'Core e estabilidade',
  functional: 'Funcionais',
  structures: 'Estruturas',
};

export interface EquipmentItem {
  id: number;
  name: string;
  category: EquipmentCategory;
  isActive: boolean;
  imageUrl?: string | null;
}

export const isEquipmentCategory = (value: string): value is EquipmentCategory => (
  EQUIPMENT_CATEGORY_ORDER.includes(value as EquipmentCategory)
);
